import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';

import * as yup from 'yup';

/** File storage response body */
export interface StorageFindInterface {
  /** Unique identifier */
  id: number;
  /** Display name */
  name: string;
  /** Endpoint address */
  endpoint: string;
}

/** File storage response body DTO schema */
export const StorageFindDto = SerdeDtoClass.create<StorageFindInterface>('storage/storage-find.dto', {
  id: {
    label: 'Номер',
    serializer: yup.number(),
  },
  name: {
    label: 'Название',
    serializer: yup.string(),
  },
  endpoint: {
    label: 'Адрес',
    serializer: yup.string(),
  },
});
